export const extractSmsTemplateVariables = (content: string): string[] =>
  Array.from(new Set(
    Array.from(content.matchAll(/#\{([^{}]+)\}/g), match => match[1])
      .filter(name => name.trim())
  ));

export const renderSmsTemplatePreview = (content: string, variables: Record<string, string>): string =>
  content.replace(/#\{([^{}]+)\}/g, (placeholder, name: string) => {
    const value = Object.prototype.hasOwnProperty.call(variables, name) ? variables[name] : '';
    return value || placeholder;
  });
